import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SEOHead({
  title = 'Motivy - Plataforma de Capital Humano y Bienestar Corporativo',
  description = 'Motivy es la plataforma líder de capital humano y bienestar corporativo. Employee engagement, reconocimiento laboral, FitRewards, salud mental y fidelización de clientes.',
  keywords = 'plataforma capital humano, software recursos humanos, bienestar corporativo, reconocimiento laboral',
  canonical,
  ogImage = 'https://customer-assets.emergentagent.com/job_f9c22ad0-e2e2-448c-9e83-2d2336da22aa/artifacts/rrp1jm6u_image.png',
  ogType = 'website',
  structuredData,
}) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="theme-color" content="#25255B" />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Motivy" />
      <meta property="og:locale" content="es_ES" />
      {canonical && <meta property="og:url" content={canonical} />}
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {canonical && <link rel="canonical" href={canonical} />}
      
      {/* Hreflang */}
      <link rel="alternate" hrefLang="es" href="https://motivyapp.com/" />
      <link rel="alternate" hrefLang="en" href="https://motivyapp.com/en/" />
      <link rel="alternate" hrefLang="x-default" href="https://motivyapp.com/" />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
}

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Motivy',
  url: 'https://motivyapp.com',
  logo: 'https://motivyapp.com/wp-content/uploads/2024/05/LOGO-FINAL-MOTIVY.webp',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'info@motivyapp.com',
    contactType: 'sales',
  },
  sameAs: [
    'https://www.youtube.com/@MotivyApp',
    'https://www.linkedin.com/company/motivyapp',
  ],
};

export const softwareSchema = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'Motivy',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Web, iOS, Android',
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.8',
    ratingCount: '150',
  },
  offers: {
    '@type': 'Offer',
    category: 'SaaS',
  },
};

export const faqSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: items.map(item => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
});

export const blogPostSchema = (post) => ({
  '@context': 'https://schema.org',
  '@type': 'BlogPosting',
  headline: post.title,
  description: post.excerpt || post.meta_description,
  image: post.image || post.og_image,
  datePublished: post.date || post.published_at,
  author: {
    '@type': 'Organization',
    name: 'Motivy',
  },
  publisher: {
    '@type': 'Organization',
    name: 'Motivy',
    logo: {
      '@type': 'ImageObject',
      url: 'https://motivyapp.com/wp-content/uploads/2024/05/LOGO-FINAL-MOTIVY.webp',
    },
  },
});
